const { VUE_APP_ENV, VUE_APP_MOCK } = process.env;

const config = {
  dev: {
    baseUrl: '//ccc-api-dev.dev-test.dragonest.com/children_center/api',
    ticketUrl: '//127.0.0.1:8888',
    communityUrl: '//ccc-community-dev.dev-test.mmxlr.com'
  },
  qa: {
    baseUrl: 'https://ccc-api-qa.dev-test.dragonest.com/children_center/api',
    ssoBaseUrl: 'https://ccc-sso-qa.dev-test.mmxlr.com/api',
    // baseUrl: 'http://172.20.11.7:5000/children_center/api',
    communityUrl: '//ccc-community-qa.dev-test.mmxlr.com'
  },
  pre: {
    baseUrl: '//172.20.11.7:5000/children_center/api',
    communityUrl: '//ccc-community-pre.dev-test.mmxlr.com'
  },
  production: {
    baseUrl: '//api.cnccbm.org.cn/children_center/api',
    ssoBaseUrl: 'https://account.cnccbm.org.cn/api',
    communityUrl: '//community-api.cnccbm.org.cn'
  },
  mock: {
    ticketUrl: VUE_APP_MOCK,
    communityUrl: '/api',
    // baseUrl: VUE_APP_MOCK
    // baseUrl: '//172.20.11.7:5000/children_center/api',
    baseUrl: '/baseApi'
    // baseUrl: '//ccc-api-qa.dev-test.dragonest.com/children_center/api'
    // baseUrl: 'https://api.cnccbm.org.cn/children_center/api'
  }
};
const KEY = VUE_APP_ENV === 'local' && VUE_APP_MOCK ? 'mock' : VUE_APP_ENV;

export default config[KEY];
